import React from "react";
import CircleWithCheck from "./CircleWithCheck";
import styles from "../../styles/public/booking-steps.module.css";
import { Button } from "reactstrap";

const BookingSteps = ({ currentStep, onEditStep, handleCancel, requiresPayment = false }) => {
    const baseSteps = [
        { number: 1, label: "Reserve" },
        { number: 2, label: "Date and Time" },
        { number: 3, label: "Book" },
    ];

    const paymentStep = { number: 4, label: "Payment" };
    const confirmStep = requiresPayment 
        ? { number: 5, label: "Confirm" }
        : { number: 4, label: "Confirm" };

    const steps = requiresPayment 
        ? [...baseSteps, paymentStep, confirmStep]
        : [...baseSteps, confirmStep];

    const finalStep = requiresPayment ? 5 : 4;

    const handleStepClick = (stepNumber) => {
        if (currentStep !== 4) {
            handleCancel();
        }
        onEditStep(stepNumber);
    }

    return (
        <div className={styles["booking-steps"]}>
            {steps.map((step, index) => {
                const isActive = currentStep === step.number;
                const isCompleted = currentStep > step.number;

                return (
                    <React.Fragment key={step.number}>
                        <div
                            className={`${styles["step"]} ${isActive ? styles.active : ""} ${isCompleted ? "completed" : ""
                                }`}
                        >
                            <div className={styles["step-circle"]}>
                                {isCompleted ? (
                                    currentStep === finalStep ? (
                                        <CircleWithCheck />
                                    ) : (
                                        <Button onClick={() => handleStepClick(step.number)} color="link">
                                            <CircleWithCheck />
                                        </Button>
                                    )
                                ) : (
                                    <div className={styles["step-number"]}>{step.number}</div>
                                )}
                            </div>
                            <div className={`${styles["step-label"]} ${isActive ? styles.active : ""}`}>{step.label}</div>
                        </div>
                        {index < steps.length - 1 && (
                            <div className={styles["step-line"]} />
                        )}
                    </React.Fragment>
                );
            })}
        </div>
    );
};

export default BookingSteps;